export class HollandCode {
    public code: string;
    public actualCode: string;
    public planetDescription: string;


    constructor(code: string, actualCode: string, name: string) {
        this.code = code;
        this.actualCode = actualCode;
        this.planetDescription = name;
    }

    public static R: HollandCode = new HollandCode("JobMatching.Phaser.hollandCodes.R", "R", "JobMatching.Phaser.hollandCodes.descriptionR");
    public static I: HollandCode = new HollandCode("JobMatching.Phaser.hollandCodes.I", "I", "JobMatching.Phaser.hollandCodes.descriptionI");
    public static A: HollandCode = new HollandCode("JobMatching.Phaser.hollandCodes.A", "A", "JobMatching.Phaser.hollandCodes.descriptionA");
    public static S: HollandCode = new HollandCode("JobMatching.Phaser.hollandCodes.S", "S", "JobMatching.Phaser.hollandCodes.descriptionS");
    public static E: HollandCode = new HollandCode("JobMatching.Phaser.hollandCodes.E", "E", "JobMatching.Phaser.hollandCodes.descriptionE");
    public static C: HollandCode = new HollandCode("JobMatching.Phaser.hollandCodes.C", "C", "JobMatching.Phaser.hollandCodes.descriptionC");
}



// WEBPACK FOOTER //
// ./src/games/JobMatchingGame/objects/HollandCode.ts